<h2 mat-dialog-title>{{ title }}</h2>

<form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
	<mat-dialog-content>
		<dl class="context">
			<dt>Loan Number</dt>
			<dd>{{ loanNumber || '—' }}</dd>
			<dt>Customer</dt>
			<dd>{{ customerName || '—' }}</dd>
		</dl>

		<formly-form
			[form]="form"
			[fields]="fields"
			[model]="model"
		></formly-form>

		<section class="payoff-statement" *ngIf="isPayoff && model.promiseDate">
			<div class="payoff-head">
				<span class="payoff-title">Payoff Statement</span>
				<mat-spinner *ngIf="isQuoting" diameter="18"></mat-spinner>
				<button
					*ngIf="currentQuote && !isQuoting"
					mat-icon-button
					color="primary"
					type="button"
					aria-label="Download payoff statement"
					matTooltip="Download payoff statement"
					(click)="onDownloadPayoff()"
				>
					<mat-icon>get_app</mat-icon>
				</button>
			</div>

			<p class="payoff-error" *ngIf="quoteError">{{ quoteError }}</p>

			<dl class="payoff-lines" *ngIf="currentQuote as q">
				<dt>Date</dt>
				<dd>{{ q.payoffDate }}</dd>
				<dt>Maturity Date</dt>
				<dd>{{ q.statement.curr_maturity_date }}</dd>
				<dt>Principal Balance</dt>
				<dd>{{ FormatUtil.formatCurrency(q.info.PrincipalBalance) }}</dd>
				<dt>Accrued Interest</dt>
				<dd>{{ FormatUtil.formatCurrency(q.info.AccruedInterest) }}</dd>
				<dt>Insurance</dt>
				<dd>{{ FormatUtil.formatCurrency(q.insurance) }}</dd>
				<ng-container *ngIf="q.includeNsf">
					<dt>NSF Fees</dt>
					<dd>{{ FormatUtil.formatCurrency(q.nsfFees) }}</dd>
				</ng-container>
				<dt>Per Diem</dt>
				<dd>{{ FormatUtil.formatCurrency(q.info.PerDiem) }}</dd>
				<dt class="total">Payoff Amount</dt>
				<dd class="total">{{ FormatUtil.formatCurrency(q.amount) }}</dd>
			</dl>
		</section>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button
			mat-stroked-button
			type="button"
			[disabled]="isSaving"
			(click)="onCancel()"
		>
			Cancel
		</button>
		<button
			mat-raised-button
			color="primary"
			type="submit"
			[disabled]="isSaving"
		>
			<mat-spinner
				*ngIf="isSaving"
				diameter="16"
				class="btn-spinner"
			></mat-spinner>
			<span>Save</span>
		</button>
	</mat-dialog-actions>
</form>
